module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-left-top-segment-visualisation-middle.293c0657.png";